import React from 'react';
import FontAwesomeAPM from "./icon/FontAwesomeAPM";

var Icon = function Icon(props) {
  return /*#__PURE__*/React.createElement(FontAwesomeAPM, props);
};

Icon.displayName = "Icon";
Icon.displayName = 'Icon';
export default Icon;